import { configureStore } from '@reduxjs/toolkit';

const store = configureStore({
    reducer: {
        // your reducers
    },
});

export default store;
